function is_touch_device() {
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
    return true;
  }

  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');

  return window.matchMedia(query).matches;
}

export const support = {
  touch: is_touch_device(),
  firefox: navigator.userAgent.indexOf('Firefox') > -1
}